import React, { useState, useEffect } from 'react'
import ToggleButton from '../../molecules/toggleButton';
import { Collapse } from '@material-ui/core';

export default function ExpandCollapseBtn(props) {
    const [isOpen, setIsOpen] = useState(true);

    const toggle = () => {
        setIsOpen(prevState => !prevState);
    }

    useEffect(() => {
        if (props.collapse) {
            setIsOpen(false)
        }
    }, [props.collapse])

    const { children, ...toggleButtonProps } = props;
    return (
        <>
            <ToggleButton
                isOpen={isOpen}
                handleClick={toggle}
                {...toggleButtonProps}
            />
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </>
    )
}
